
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import Icone from '@/core/components/UI/Icone.vue';
import ManualPreenchimentoInspecao from '@/models/Constantes/ManualPreenchimentoInspecao';
import { IInspecaoSecao4 } from '@/models/Entidades/IInspecao';

export default defineComponent({
  name: 'InspecaoSecao4',
  props: {
    secao4: {
      type: Object as () =>IInspecaoSecao4,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    Icone,
  },
  emits: ['update:secao4', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
      manuaisPreenchimento: {} as Record<string, boolean>,
    });

    const computedSecao4 = computed({
      get: () => props.secao4,
      set: (valor: IInspecaoSecao4) => {
        emit('update:secao4', valor);
      },
    });

    function change() {
      emit('change');
    }

    function alternarManualPreenchimento(chave: string) {
      state.manuaisPreenchimento[chave] = !state.manuaisPreenchimento[chave];
    }

    return {
      props,
      computedSecao4,
      state,
      change,
      ManualPreenchimentoInspecao,
      alternarManualPreenchimento,
    };
  },
});
